import { useEffect } from 'react';
import {
  isKidsComboEditHydrating,
  isKidsComboModifierStep,
  resetKidsComboPulseViewSession,
  syncKidsComboPulseViewForStep,
} from './pulseKidsComboViews';

type ModifierGroupPulseSlice = {
  id?: unknown;
  type?: unknown;
};

/**
 * Pulse view tracking for Kids Combo item picker (ChoseItemModal only).
 * Step 1 → kidscombo_menu; step 2+ → customization_modal (once each per open).
 */
export function useKidsComboPulseViews(params: {
  isCustomize: boolean;
  itemStack: { length: number } | null | undefined;
  modifierGroup: ModifierGroupPulseSlice | null | undefined;
  pagePath?: string;
}): void {
  const { isCustomize, itemStack, modifierGroup, pagePath } = params;

  useEffect(() => {
    resetKidsComboPulseViewSession();
    return () => resetKidsComboPulseViewSession();
  }, []);

  useEffect(() => {
    if (
      isKidsComboEditHydrating({
        isCustomize,
        itemStackLength: itemStack?.length ?? 0,
      })
    ) {
      return;
    }

    syncKidsComboPulseViewForStep({
      isStepOne: !isKidsComboModifierStep(itemStack, modifierGroup),
      pagePath,
    });
  }, [
    isCustomize,
    itemStack?.length,
    modifierGroup?.id,
    modifierGroup?.type,
    pagePath,
  ]);
}
